<template>
  <div>
    <h2>{{ $t('ambassadors.list.mainTitle') }}</h2>
    <div v-if="loadingShow" class="d-flex justify-content-center mb-3">
      <span><b-spinner small class="loading-spinner mr-2"></b-spinner>Data is loading...</span>
    </div>

    <b-alert v-model="hasError" variant="danger" fade>
      {{ errorMessage }}
    </b-alert>

    <dx-data-grid
      v-show="dataIsLoaded"
      :ref="dataGridAmbassadors"
      id="gridContainerAmbassadors"
      :data-source="items"
      :allow-column-reordering="false"
      :allow-column-resizing="true"
      :column-min-width="50"
      columnResizingMode="widget"
      :show-borders="true"
      :showColumnLines="true"
      :showRowLines="true"
      key-expr="field_001"
      :no-data-text="$t('general.noEntries')"
      :column-auto-width="false"
      :word-wrap-enabled="true"
      @row-updated="onUpdateRow"
      @editing-start="onEditingStart"
      @contentReady="contentReady"
      :sync-lookup-filter-values="false"
    >

      <dx-filter-panel :visible="true"/>

      <dx-scrolling mode="virtual"/>

      <dx-filter-row
        :visible="true"
        apply-filter=""
      />

      <dx-header-filter
        :visible="true"
      />

      <dx-column-chooser
        :enabled="true"
        mode="select"
      >
        <dx-column-chooser-search
          :enabled="true"
        />
      </dx-column-chooser>

      <dx-search-panel
        :visible="true"
        :width="320"
        placeholder="Search..."
      />

      <dx-editing
        refresh-mode="repaint"
        :allow-updating="true"
        mode="cell"
      />

      <dx-column
        data-field="crm_adress_id"
        data-type="number"
        :caption="$t('ambassadors.list.id')"
        :fixed="true"
        :width="80"
        :allow-editing="false"
      />
      <dx-column
        data-field="cRMAddress.salutationId"
        data-type="number"
        :caption="$t('ambassadors.list.salutation')"
        :width="100"
      >
        <dx-lookup
          :data-source='salutationTypes'
          :display-expr='getDisplayExpr'
          value-expr='ansprechzeile_id'
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="cRMAddress.titel"
        data-type="string"
        :caption="$t('ambassadors.list.title')"
        :width="100"
      />
      <dx-column
        data-field="cRMAddress.firstname"
        data-type="string"
        :caption="$t('ambassadors.list.firstname')"
        :width="150"
      />
      <dx-column
        data-field="cRMAddress.lastname"
        data-type="string"
        :caption="$t('ambassadors.list.lastname')"
        :width="150"
      />
      <dx-column
        data-field="cRMAddress.company"
        data-type="string"
        :caption="$t('ambassadors.list.company')"
        :width="150"
      />
      <dx-column
        data-field="cRMAddress.company2"
        data-type="string"
        :caption="$t('ambassadors.list.company2')"
        :width="150"
      />
      <dx-column
        data-field="cRMAddress.division"
        data-type="string"
        :caption="$t('ambassadors.list.division')"
        :width="150"
      />
      <dx-column
        data-field="cRMAddress.position"
        data-type="string"
        :caption="$t('ambassadors.list.position')"
        :width="150"
      />
      <dx-column
        data-field="cRMAddress.organisationTypeId"
        data-type="number"
        :caption="$t('ambassadors.list.organisationTypeId')"
        :width="200"
      >
        <dx-lookup
          :data-source="typeofOrganization"
          display-expr="typeofOrganization"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="cRMAddress.priovlabId"
        data-type="string"
        :caption="$t('ambassadors.list.priovlab')"
        :width="100"
      >
        <dx-lookup
          :data-source="priovlabTypes"
          display-expr="status"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        data-field="cRMAddress.emailB1"
        data-type="string"
        :caption="$t('ambassadors.list.emailB')"
        :width="100"
      >
        <dx-email-rule/>
      </dx-column>
      <dx-column
        data-field="cRMAddress.phoneB"
        data-type="string"
        :caption="$t('ambassadors.list.phoneB')"
        :width="120"
      />
      <dx-column
        data-field="cRMAddress.mobileB"
        data-type="string"
        :caption="$t('ambassadors.list.mobileB')"
        :width="120"
      />
      <dx-column
        data-field="cRMAddress.internetB"
        data-type="string"
        :caption="$t('ambassadors.list.internetB')"
        :width="150"
      >
        <dx-pattern-rule
          :pattern="pattern"
          message="Enter a valid URL"
        />
      </dx-column>
      <dx-column
        data-field="cRMAddress.linkedInB"
        data-type="string"
        :caption="$t('ambassadors.list.linkedInB')"
        :width="120"
      />
      <dx-column
        data-field="cRMAddress.twitterB"
        data-type="string"
        :caption="$t('ambassadors.list.twitterB')"
        :width="120"
      />
      <dx-column
        data-field="cRMAddress.facebookB"
        data-type="string"
        :caption="$t('ambassadors.list.facebookB')"
        :width="120"
      />
      <dx-column
        data-field="cRMAddress.instagramB"
        data-type="string"
        :caption="$t('ambassadors.list.instagramB')"
        :width="120"
      >
        <dx-pattern-rule
          :pattern="pattern"
          message="Enter a valid URL"
        />
      </dx-column>
      <dx-column
        data-field="cRMAddress.streetB"
        data-type="string"
        :caption="$t('ambassadors.list.streetB')"
        :width="120"
      />
      <dx-column
        data-field="cRMAddress.zipB"
        data-type="string"
        :caption="$t('ambassadors.list.zipB')"
        :width="100"
      />
      <dx-column
        data-field="cRMAddress.cityB"
        data-type="string"
        :caption="$t('ambassadors.list.cityB')"
        :width="120"
      />
      <dx-column
        data-field="cRMAddress.countryBId"
        data-type="string"
        :caption="$t('ambassadors.list.countryB')"
        :width="150"
      >
        <dx-lookup
          :data-source="countryTypes"
          display-expr="land"
          value-expr="field_001"
          :allow-clearing="true"
        />
      </dx-column>
      <dx-column
        caption=""
        cell-template="button-template"
        type="buttons"
        :showInColumnChooser="false"
        :fixed="true"
        :width="80"
      />
      <template #button-template="{ data }">
        <a :href="`https://crm.ifj.ch/index.cfm?&page=115966&ADDRESSESID=${data.data.crm_adress_id}`" target="_blank"><i class="fas fa-pen mr-3"></i></a>
      </template>
      <template #totalGroupCount>
        <div class="informer" v-if="totalCount > 0">
          <span class="count">{{ filteredCount }} results out of {{ totalCount }} records</span>
        </div>
      </template>
      <dx-toolbar>
        <dx-item
          location="before"
          template="totalGroupCount"
        />
        <dx-item
          name="searchPanel"
        />
        <!-- <dx-item
          location="after"
          template="rolesfiltermenu"
        /> -->
        <dx-item
          location="after"
          template="actionmenu"
        />
      </dx-toolbar>
      <!-- <template #rolesfiltermenu>
        <div>
          <v-menu
            offset-y
            bottom
            left
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="secondary"
                outlined
                v-bind="attrs"
                v-on="on"
              >
                <i class="fas fa-users"></i> Roles
              </v-btn>
            </template>
            <v-list
              dense
              max-width="300"
              max-height="500"
              class="roles-list"
            >
              <v-subheader>Select at least one role {{selectedRoles}}</v-subheader>
              <v-list-item-group v-model="selectedRoles">
                <v-list-item
                  v-for="(role, index) in roles"
                  :key="role.field_001"
                >
                  <v-checkbox
                    dense
                    multiple
                    color="secondary"
                    :hide-details="index !== roles.length - 1"
                    :value="role.field_001"
                    :label="role.rolle" />
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </div>
      </template> -->
      <template #actionmenu>
        <div>
          <v-menu
            offset-y
            bottom
            left
            content-class="toolbar-action-menu"
          >
            <template v-slot:activator="{ attrs, on }">
              <v-btn
                color="secondary"
                v-bind="attrs"
                v-on="on"
              >
                <i class="fas fa-cog"></i> Actions
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                link
                @click="openColumnChooser"
              >
                <v-list-item-title><i class="fas fa-columns mr-1"></i> Column Chooser</v-list-item-title>
              </v-list-item>
              <v-list-item
                link
                @click="onExporting"
              >
                <v-list-item-title><i class="fas fa-file-excel mr-2"></i> Excel Export</v-list-item-title>
              </v-list-item>
              <v-tooltip left max-width="400" open-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    @click="saveState"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-list-item-title><i class="fas fa-save mr-2"></i> Save Template</v-list-item-title>
                  </v-list-item>
                </template>
                <span>Save the columns template</span>
              </v-tooltip>
              <v-tooltip left max-width="400" open-delay="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    link
                    @click="loadState"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-list-item-title><i class="fas fa-download mr-2"></i> Load Template</v-list-item-title>
                  </v-list-item>
                </template>
                <span>Open a columns template</span>
              </v-tooltip>
            </v-list>
          </v-menu>
        </div>
      </template>
    </dx-data-grid>
    <save-template :template="template"/>
    <load-template :tableType="tableType" @set-state-4="loadSelectedTemplate" @set-default-state-4="loadDefaultTemplate"/>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { exportDataGrid } from 'devextreme/excel_exporter'
  import ExcelJS from 'exceljs'
  import saveAs from 'file-saver'
  import SaveTemplate from '@/components/template/SaveTemplate.vue'
  import LoadTemplate from '@/components/template/LoadTemplate.vue'
  // import DxButton from 'devextreme-vue/button'
  import moment from 'moment'
  import {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSearchPanel,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxHeaderFilter,
    DxFilterRow,
    DxFilterPanel,
    DxLookup,
    DxEditing,
    DxEmailRule,
    DxPatternRule,
    DxToolbar,
    DxItem
  } from 'devextreme-vue/data-grid'

  const dataGridAmbassadors = 'dataGrid'

  export default {
    components: {
      DxDataGrid,
      DxColumn,
      DxScrolling,
      DxSearchPanel,
      DxColumnChooser,
      DxColumnChooserSearch,
      DxHeaderFilter,
      DxFilterRow,
      DxFilterPanel,
      DxLookup,
      // DxButton,
      SaveTemplate,
      LoadTemplate,
      DxEditing,
      DxEmailRule,
      DxPatternRule,
      DxToolbar,
      DxItem
    },
    data () {
      return {
        hasError: false,
        errorMessage: '',
        loadingShow: true,
        dataIsLoaded: false,
        template: {},
        tableType: 4,
        defaultState: null,
        dataGridAmbassadors,
        totalCount: 0,
        filteredCount: 0,
        currentDate: new Date(),
        // selectedRoles: [],
        // pattern: /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/ /* eslint-disable-line */
        pattern: '((http|https)://)|([A-Za-z]{2,}[.][A-Za-z]{2,})'
      }
    },
    created () {
      this.getBasicValues('basicValues/GET_SALUTATION_TYPES', this.salutationTypes)
      this.getBasicValues('basicValues/GET_PRIOVLAB_TYPES', this.priovlabTypes)
      this.getBasicValues('basicValues/GET_COUNTRY_TYPES', this.countryTypes)
      this.getBasicValues('basicValues/GET_TYPE_OF_ORGANIZATION', this.typeofOrganization)
      // this.getBasicValues('basicValues/GET_ROLES', this.roles)
      this.onGetAmbassadorsList()
    },
    mounted () {
      this.defaultState = JSON.stringify(this.dataGrid.state())
    },
    methods: {
      async getBasicValues (storePath, storeValue) {
        if (storeValue.length === 0) {
          try {
            const { errors } = await this.$store.dispatch(storePath)
            if (errors) throw errors
          } catch (err) {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            setTimeout(() => {
              this.hasError = false
            }, 5000)
          }
        }
      },
      async onGetAmbassadorsList () {
        this.hasError = false
        this.$Progress.start()

        try {
          const { errors } = await this.$store.dispatch('recherche/GET_AMBASSADORS_LISTS')
          if (errors) throw errors
          this.totalCount = this.items.length
          this.loadingShow = false
          this.dataIsLoaded = true
          this.$Progress.finish()
        } catch (err) {
          this.hasError = true
          this.$Progress.fail()
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          this.loadingShow = false
          this.dataIsLoaded = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      async onUpdateRow (rowData) {
        const editedQuery = this.editRowKey.split('.')
        const isAddressUpdate = editedQuery.includes('cRMAddress')

        if (isAddressUpdate) {
          if (rowData.data.cRMAddress.priovlabId === null) {
            rowData.data.cRMAddress.priovlabId = 7
          }
          rowData.data.cRMAddress.salutationId = parseInt(rowData.data.cRMAddress.salutationId)
          if (rowData.data.cRMAddress.countryBId === null) {
            rowData.data.cRMAddress.countryBId = -1
          }
          if (rowData.data.cRMAddress.organisationTypeId === null) {
            rowData.data.cRMAddress.organisationTypeId = -1
          }
          const { cRMAddress } = rowData.data
          this.onUpdateAddress(cRMAddress)
          // after sending the -1 to the gql, write again null for the select
          if (rowData.data.cRMAddress.priovlabId === -1) {
            rowData.data.cRMAddress.priovlabId = null
          }
          if (rowData.data.cRMAddress.countryBId === -1) {
            rowData.data.cRMAddress.countryBId = null
          }
          if (rowData.data.cRMAddress.organisationTypeId === -1) {
            rowData.data.cRMAddress.organisationTypeId = null
          }
        }
      },
      async onUpdateAddress (data) {
        try {
          const { errors } = await this.$store.dispatch('recherche/UPDATE_AMBASSADORS_ADDRESS', {
            formData: data
          })
          if (!errors) {
            this.hasError = false
          }
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      onEditingStart (e) {
        this.editRowKey = e.column.dataField
      },
      getDisplayExpr (item) {
        return item.geschlecht_PopupExtension ? `${item.ansprechzeile} ${item.geschlecht_PopupExtension}` : `${item.ansprechzeile}`
      },
      contentReady () {
        this.filteredCount = this.dataGrid.totalCount()
      },
      loadDefaultTemplate () {
        const state = JSON.parse(this.defaultState)
        this.dataGrid.state(state)
      },
      loadSelectedTemplate (state) {
        state = JSON.parse(state)
        this.dataGrid.state(state)
      },
      loadState () {
        this.$store.commit('template/SET_LOAD_TEMPLATE_STATUS', true)
      },
      saveState () {
        this.template = {
          state: JSON.stringify(this.dataGrid.state()),
          table_type: this.tableType,
          creator: this.currentUser.mitarbeiterId
        }
        this.$store.commit('template/SET_SAVE_TEMPLATE_STATUS', true)
      },
      onExporting () {
        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Ambassadors')

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${moment(this.currentDate).format('DD.MM.YYYY')}-Ambassadors.xlsx`)
          })
        })
        this.dataGrid.cancel = true
      },
      openColumnChooser () {
        this.dataGrid.showColumnChooser()
      }
    },
    computed: {
      ...mapGetters({
        items: 'recherche/AMBASSADORSLIST',
        salutationTypes: 'basicValues/SALUTATION_TYPES',
        priovlabTypes: 'basicValues/PRIOVLAB_TYPES',
        countryTypes: 'basicValues/COUNTRY_TYPES',
        typeofOrganization: 'basicValues/TYPEOFORGANIZATION'
        // roles: 'basicValues/ROLES'
      }),
      ...mapState({
        currentUser: state => state.user.currentUser
      }),
      dataGrid: function () {
        return this.$refs[dataGridAmbassadors].instance
      }
    }
  }
</script>
<style>
#gridContainerAmbassadors {
    height: 78vh;
    margin-bottom: 0;
}

.btn-pdl {
  margin: 0 0 0 5px;
}

.dx-data-row.dx-state-hover:not(.dx-selection):not(.dx-row-inserted):not(.dx-row-removed):not(.dx-edit-row) > td:not(.dx-focused) {
    cursor: pointer;
}

.v-list.roles-list input {
  opacity: 1;
}

.v-list.roles-list .v-input {
  margin-top: 0;
  padding-top: 0;
}

.v-list.roles-list .v-label {
  margin-bottom: 0;
}
</style>
